import { useQuery } from '@tanstack/react-query';

import type { AddressSearchParams } from '@/modules/entities';

import { addressBookSearchOptions } from '../data-provider';

export const useAddressBookSearch = (
  params: AddressSearchParams,
  options?: { enabled?: boolean; onError?: (error: unknown) => void },
) =>
  useQuery({
    ...addressBookSearchOptions(params, { onError: options?.onError }),
    enabled: options?.enabled ?? true,
  });
